require('bootstrap4');
require('popper.js');

$(function () {
    //scroll
    $('.menu .navbar-nav a[href^="#"]').click( function(){
        let scroll_el = $(this).attr('href');

        if ($(scroll_el).length !== 0) {
            $('html, body').animate({ scrollTop: $(scroll_el).offset().top }, 1000);
        }
        return false;
    });

    //scroll arrow up
    $(window).scroll(function () {
        let scroll = $('#scrollup');

        //hide scroll arrow for phone
        if (window.innerWidth < 767) {
            scroll.fadeOut(1000);
            return;
        }

        //animation hidden adn show scroll arrow
        if ($(document).scrollTop() > 0) {
            scroll.fadeIn(1000);
        } else {
            scroll.fadeOut(1000);
        }
    });

    $('#scrollup img').hover(function () {
        $(this).animate({opacity: 0.65}, 100);
    }, function () {
        $(this).animate({opacity: 1}, 100);
    }).click(function () {
        $('html, body').animate({
            scrollTop: $('#anchor').offset().top
        }, 2000);
    });
});